import { defineStore } from 'pinia'
import { ref } from 'vue'

export type SnackbarColor = 'success' | 'error' | 'info' | 'warning'

export const useSnackbarStore = defineStore('snackbar', () => {
  const visible = ref(false)
  const message = ref('')
  const color = ref<SnackbarColor>('info')
  const timeout = ref(4000)

  function show(msg: string, c: SnackbarColor = 'info', to: number = 4000) {
    message.value = msg
    color.value = c
    timeout.value = to
    visible.value = true
  }

  function success(msg: string) { show(msg, 'success') }
  function error(msg: string) { show(msg, 'error') }
  function info(msg: string) { show(msg, 'info') }
  function warning(msg: string) { show(msg, 'warning') }

  return { visible, message, color, timeout, show, success, error, info, warning }
})